// „Lerne aus Fehlern“: Aufgabe neben dem Brett und die Brett-Einstellungen dazu.
import type { Config } from '@lichess-org/chessground/config';
import { h, type VNode } from 'snabbdom';
import { t } from '../i18n';
import type { PlayCtrl } from '../playctrl';
import type { Training } from '../playtrain';
import { WORD } from './playhelp';

const btn = (label: string, on: () => void) => h('button.btn', { on: { click: on } }, t(label));

/** Brett in der Aufgabe: Stellung vor dem Fehler, aus Sicht der Seite am Zug */
export function trainBoard(tr: Training): Config {
  const turn = tr.fen.split(' ')[1] === 'b' ? 'black' : 'white';
  return {
    fen: tr.fen,
    orientation: tr.color,
    turnColor: turn,
    check: tr.board.pos.isCheck() ? turn : false,
    lastMove: tr.last,
    movable: { free: false, color: tr.color, dests: tr.dests(), showDests: true, events: { after: (o, d) => void tr.move(o, d) } },
    drawable: { enabled: true, visible: true, autoShapes: tr.shapes() },
  };
}

export function trainPanel(c: PlayCtrl, tr: Training): VNode {
  const n = tr.slips.length;
  return h('div.setup.coach', [
    h('div.hd', h('div.row', [h('h3', t('Lerne aus Fehlern')), h('span.muted.small', tr.done ? '' : `${tr.index + 1} / ${n}`)])),
    h('div.fld', tr.done ? finished(c, tr) : task(tr)),
    h('div.fld', h('div.row.btns', [btn('Zurück zur Partie', () => c.stopTraining())])),
  ]);
}

function finished(c: PlayCtrl, tr: Training): VNode[] {
  return [
    h('p', t('Fertig: {a} von {b} selbst gefunden.', { a: tr.solved, b: tr.slips.length })),
    h('div.row.btns', [btn('Noch einmal', () => c.startTraining())]),
  ];
}

function task(tr: Training): VNode[] {
  const s = tr.slip;
  const intro = h('p', [
    h(`span.${s.judgement}`, `${t(WORD[s.judgement])}: ${s.playedSan}`),
    ' ' + t('Finde einen besseren Zug.'),
  ]);
  switch (tr.state) {
    case 'checking':
      return [intro, h('p.muted.small', t('Der Coach prüft deinen Zug …'))];
    case 'wrong':
      return [intro, h('p.warn', t('Nicht ganz. Noch ein Versuch?')), h('div.row.btns', [btn('Lösung zeigen', () => tr.reveal())])];
    case 'right':
      return [h('p.ok', tr.last?.join('') === s.best.slice(0, 4) ? t('Richtig: {m}.', { m: s.bestSan }) : t('Gut gefunden. Stockfish empfiehlt {m}.', { m: s.bestSan })),
        h('div.row.btns', [btn('Weiter', () => tr.next())])];
    case 'shown':
      return [intro, h('p', t('Lösung: {m}', { m: s.bestSan })), h('div.row.btns', [btn('Weiter', () => tr.next())])];
    default:
      return [intro];
  }
}
